import { render, staticRenderFns } from "./PromotersList.vue?vue&type=template&id=a5b7c6cc"
import script from "./PromotersList.vue?vue&type=script&lang=js"
export * from "./PromotersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports